global.config = {
  apiPrefix: 'https://api-freeagent-com.auth.codeite.net/v2',
  apiDomain: 'api.freeagent.com',
  loginUrl: 'https://auth.codeite.net/login',
  authorizeUrl: 'http://auth.codeite.net/authorize'
}



// WEBPACK FOOTER //
// ./src/config-live.js